import { render, staticRenderFns } from "./tenantModal.vue?vue&type=template&id=f8ba41ba&"
import script from "./tenantModal.vue?vue&type=script&lang=js&"
export * from "./tenantModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports